import DynamicDashboard from 'components/DynamicDashboard';
import { Query } from 'hooks/useTableFilters';
import i18n from 'i18n';
import React from 'react';
import EnvironmentsDashboardConfiguration from './DashboardConfiguration';
import { useEnvironmentsDashboard } from './useEnvironmentsDashboard';

interface DashboardCardsProps {
  filters: Record<string, string>;
  onApplyFilter: () => void;
  setQuery: React.Dispatch<React.SetStateAction<Query>>;
}

const DashboardCards = ({
  filters,
  onApplyFilter,
  setQuery,
}: DashboardCardsProps) => {
  const dashboardProps = useEnvironmentsDashboard({ filters });

  return (
    <DynamicDashboard
      filters={filters}
      storageKey="selectedGraphs"
      title={i18n.t('ENV_DASHBOARD_KEY')}
      dashboardModalTitle={i18n.t('CONFIG_ENV_DASHBOARD_MODAL_KEY')}
      getDashboardConfiguration={props => (
        <EnvironmentsDashboardConfiguration filters={filters} {...props} />
      )}
      onApplyFilter={onApplyFilter}
      setQuery={setQuery}
      {...dashboardProps}
    />
  );
};

export default DashboardCards;
